import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LoginComponent } from '../../pages/login/login.component';

declare let bootstrap: any;

@Component({
  selector: 'kt-app-login-modal',
  imports: [CommonModule, LoginComponent],
  templateUrl: './login-modal.component.html',
  styleUrl: './login-modal.component.scss'
})
export class LoginModalComponent {
  private router = inject(Router);

  private modalInstance: any;

  open(): void {
    const modalEl = document.getElementById('loginModal');

    if (!this.modalInstance) {
      this.modalInstance = new bootstrap.Modal(modalEl, {
        backdrop: 'static',
        keyboard: false
      });
    }

    this.modalInstance.show();
  }

  close(): void {
    this.modalInstance?.hide();
  }

  onLoginSuccess(): void {
    this.close();
  }

  onNavigateAway(navigateUrl: string){
    this.close();

    setTimeout(() => {
      this.router.navigate([navigateUrl]);
    }, 200);
  } 
}
